<template>
  <div class="row">
    <div>
      <api-header id="errors" tag="h2">{{ $t('documentation.api.errors.title') }}</api-header>
      <i18n-t keypath="documentation.api.errors.description.summary" tag="p" scope="global" />
      <i18n-t keypath="documentation.api.errors.description.learnMore.message" tag="p" scope="global">
        <template #link>
          <link-wrapper href="/api-errors">{{
            $t('documentation.api.errors.description.learnMore.linkText')
          }}</link-wrapper>
        </template>
      </i18n-t>
      <api-errors-table :error-page-url="`/api-errors/${id}`" :errors="document.errors" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { PropType } from 'vue';
import { ApiDoc } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import LinkWrapper from '@/components/markdown/widgets/LinkWrapper.vue';
import ApiErrorsTable from '@/components/api/errors/ApiErrorsTable.vue';

defineProps({
  id: { type: String, required: true },
  document: { type: Object as PropType<ApiDoc>, required: true },
});
</script>
